import api from "./api";

class ExpenseService {
    list(startDate, endDate) {
        const params = {};
        if (startDate) params.start_date = startDate;
        if (endDate) params.end_date = endDate;
        return api.get("/api/expenses/list/", { params });
    }

    getMileRates() {
        return api.get("/api/expenses/mile-rates/");
    }

    getPerDiemRates() {
        return api.get("/api/expenses/per-diem-rates/");
    }

    createCompanyCard(formData) {
        return api.post("/api/expenses/company-card/", formData, {
            headers: { "Content-Type": "multipart/form-data" },
        });
    }

    searchCompanyCard(query) {
        return api.get("/api/expenses/company-card/search/", { params: { q: query } });
    }

    getCompanyCardReceipt(id) {
        return api.get(`/api/expenses/company-card/${id}/receipt/`, { responseType: "blob" });
    }

    getReimbursableReceipt(id) {
        return api.get(`/api/expenses/reimbursements/${id}/receipt/`, { responseType: "blob" });
    }

    createReimbursable(formData) {
        return api.post("/api/expenses/reimbursements/", formData, {
            headers: { "Content-Type": "multipart/form-data" },
        });
    }

    createMiles(data) {
        return api.post("/api/expenses/miles/", data);
    }

    createPerDiem(data) {
        return api.post("/api/expenses/per-diem/", data);
    }

    updateCompanyCard(id, formData) {
        return api.patch(`/api/expenses/company-card/${id}/`, formData, {
            headers: { "Content-Type": "multipart/form-data" },
        });
    }

    updateReimbursable(id, formData) {
        return api.patch(`/api/expenses/reimbursements/${id}/`, formData, {
            headers: { "Content-Type": "multipart/form-data" },
        });
    }

    updateMiles(id, data) {
        return api.patch(`/api/expenses/miles/${id}/`, data);
    }

    updatePerDiem(id, data) {
        return api.patch(`/api/expenses/per-diem/${id}/`, data);
    }

    deleteCompanyCard(id) {
        return api.delete(`/api/expenses/company-card/${id}/`);
    }

    deleteReimbursable(id) {
        return api.delete(`/api/expenses/reimbursements/${id}/`);
    }

    approve(expenseType, id, isApproved = true) {
        return api.patch("/api/expenses/approve/", {
            expense_type: expenseType,
            id,
            is_approved: isApproved,
        });
    }

    markPaid(expenseType, id, isPaid = true) {
        return api.patch("/api/expenses/reimbursable/paid/", {
            expense_type: expenseType,
            id,
            is_paid: isPaid,
        });
    }
}

export default new ExpenseService();
